export default {"src":"/login-app/[GIT_HASH]/_next/static/media/status.54ea4cda.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};